import dayjs from 'dayjs';
import store from '@/store';
import i18n from '@/i18n';
import S_answerSettingItem from '@/service/api/v1/answerSettingItem';
import S_systemClassAnalysis from '@/service/api/v1/systemclass_analysis';
import H_card from "@/helpers/card";
import H_time from '@/helpers/time';
import H_file from '@/helpers/file';
import H_common from "@/helpers/common";
import H_factoryTag from '@/helpers/factoryTag';
import H_answerSetting from '@/helpers/answerSetting';
import H_checklistRecord from '@/helpers/checklistRecord';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';
import H_systemClassMenu from '@/helpers/systemClassMenu';
import Spare_checklist from '@/spare/checklist';
import Spare_checklistBoardTable from '@/spare/checklist-board-table';

export default {
  setChecklistData(data, factorySystemClassRows = []) {
    const {
      id,
      name,
      owner,
      system_classes,
      system_subclasses,
      factory_system_classes,
      factory_system_subclasses,
      is_collect: isCollect,
      has_draft: hasDraft,
      factory_tags,
      created_user: creator,
      has_renew_template: hasRenewTemp,
      general_schedule_setting_count: scheduleSettingCount,
      has_assignment: hasAssignment,
      last_version
    } = data;

    return {
      id,
      versionId: last_version ? last_version.id : null,
      name,
      ownerValue: owner,
      owner: owner ? owner.id : null,
      multiSystemClassChips: H_systemClassMenu.formatMultiSystemClassContentChips(
        { system_classes, system_subclasses, factory_system_classes, factory_system_subclasses },
        { factorySystemClassRows },
      ),
      isCollect,
      hasDraft,
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
      creator,
      hasRenewTemp,
      scheduleSettingCount,
      reviewers: [],
      reviewersValue: [],
      hasAssignment,
    };
  },
  setUpdateChecklistData(data) {
    return {
      id: data.id,
      versionId: data.last_version ? data.last_version.id : null,
      name: data.name,
      ownerValue: data.owner,
      owner: data.owner ? data.owner.id : null,
      multiSystemClasses: [],
      multiSystemClassesSelectValue: {
        system_classes: data.system_classes || [],
        system_subclasses: data.system_subclasses || [],
        factory_system_classes: data.factory_system_classes || [],
        factory_system_subclasses: data.factory_system_subclasses || [],
      },
      factoryTags: [data.factory_tags.map(tag => tag.id)],
    };
  },
  async setShowQues(rawData) {
    const {
      id,
      checklist_question_template: template,
      is_deleted_template: isTempQuesDeleted,
      is_renew_template: isTempQuesRenew,
      last_version: lastVersion,
    } = rawData;
    const {
      id: versionId,
      question_type_setting: quesType,
      title,
      checklist_question_template_version: templateVersion,
      remark,
      template_attaches: tempAttaches,
      effects,
      factory_effects: factoryEffects,
      keypoint,
      file_attaches,
      file_images,
      file_ocap_attaches,
      file_ocap_images,
      ocap_remark: ocapRemark,
      is_in_stats: isInStats,
      answer_setting: answerSetting,
      unit,
      question_setting_items,
      related_guidelines,
    } = lastVersion;
    const _tempAttaches = tempAttaches.map(attach => {return {url: attach}});
    const chip = isTempQuesDeleted
      ? {
          color: 'gray',
          text: '建議題目已移除'
        }
      : isTempQuesRenew
      ? {
          color: 'yellow',
          text: '建議題目版本更新'
        }
      : null;
    let resultQues = {
      id,
      versionId,
      templateId: template ? template.id : null,
      templateVersionId: templateVersion ? templateVersion.id : null,
      title,
      quesType,
      remark: remark ? remark : '無',
      keypoint: keypoint === 1
        ? {
            color: 'green',
            textContent: i18n.t('重點關注'),
            text: i18n.t('重點關注'),
          }
        : null,
      ocapRemark: ocapRemark ? ocapRemark : '無',
      attaches: H_file.setShowInModule(file_attaches),
      images: H_file.setShowInModule(file_images),
      ocapAttaches: H_file.setShowInModule(file_ocap_attaches),
      ocapImages: H_file.setShowInModule(file_ocap_images),
      controlLimitDataLower: null,
      controlLimitDataUpper: null,
      controlLimitData: null,
      specLimitDataLower: null,
      specLimitDataUpper: null,
      specLimitData: null,
      tempAttaches: _tempAttaches,
      allAttaches: [...H_file.setTempFileShowInModule(tempAttaches), ...H_file.setShowInModule(file_attaches)],
      chip,
      isInStats,
      isInStatsText: isInStats ? '是' : '否',
      answerSetting,
      guidelineList: H_guidelineVersionAdmin.setShowRelatedGuideline(related_guidelines),
    };
    if (quesType.value === 'num') {
      resultQues = await this.applyNumQuestionTypeShow(resultQues, {
        answerSetting,
        unit,
        questionSettingItems: question_setting_items,
      });
    } else if (quesType.value === 'single-choice') {
      resultQues.optionList = this.setSingleChoiceOptionList(question_setting_items);
    }
    const lawList = H_common.setLawList(lastVersion);
    resultQues.lawLinks = lawList;
    resultQues.effects = [effects, factoryEffects];
    if (lawList.length) {
      resultQues.lawList = null;
    } else {
      resultQues.lawList = '無';
    }
    return resultQues;
  },
  setSingleChoiceOptionList(questionSettingItems = []) {
    return questionSettingItems.map((item) => {
      const {
        name: title,
        answer_setting_item: answerSettingItem,
        common_choice: commonChoice,
        has_child,
        has_remark,
        id,
        risk_level,
        question_setting_items: childItems = [],
      } = item;
      const hasSubOption = has_child === 1;
      const risk = this.setRiskLevelText(risk_level);
      return {
        id,
        title,
        answerSettingItem,
        commonChoice,
        hasSubOption,
        requiredRemark: hasSubOption ? false : !!has_remark,
        risk,
        riskValue: risk_level,
        subOptionList: has_child
          ? childItems.map(({ name: title, answer_setting_item: answerSettingItem, common_choice: commonChoice, has_remark, id, risk_level }) => ({
              id,
              title,
              answerSettingItem,
              commonChoice,
              requiredRemark: !!has_remark,
              risk: this.setRiskLevelText(risk_level),
              riskValue: risk_level,
            }))
          : [],
      };
    });
  },
  setShowTempQues(rawData) {
    const {
      id,
      last_version: lastVersion,
      updated_at: updatedAt,
    } = rawData;
    const {
      id: versionId,
      question_type_setting: quesType,
      title,
      remark,
      attaches,
      effects,
      is_in_stats: isInStats,
      answer_setting,
      question_template_setting_items,
      control_limit_suggest: controlLimitSuggest,
      spec_limit_suggest: specLimitSuggest,
      unit,
    } = lastVersion;
    let resultQues = {
      id,
      versionId,
      quesType,
      title,
      subTitle: `${i18n.t('ESGoal建議題目範本')} (${i18n.t('更新日期')} : ${H_time.getDateDashFormat(updatedAt)})`,
      remark: remark ? remark : '無',
      tempAttaches: H_file.setTempFileShowInModule(attaches),
      controlLimitData: '',
      specLimitData: '',
      isInStats,
      isInStatsText: isInStats ? '是' : '否',
    };
    if (quesType.value === 'single-choice') {
      const optionList = question_template_setting_items.map(rawItem => {
        const {
          id,
          name: title,
          risk_level,
          has_child,
          has_remark,
        } = rawItem.answer_setting_item;
        let resultItem =  {
          id,
          title,
          hasSubOption: has_child === 1,
          requiredRemark: has_child === 1 ? false : has_remark === 1,
          risk_level,
          risk: has_child === 1 ? '' : this.setRiskLevelText(risk_level),
          subOptionList: [],
          answer_setting_item: rawItem.answer_setting_item,
          question_template_setting_items: rawItem.question_template_setting_items,
        };
        if (has_child === 1) {
          resultItem.subOptionList = rawItem.question_template_setting_items.map(subTempItem => {
            const {
              id,
              name: title,
              risk_level,
              has_remark,
            } = subTempItem.answer_setting_item;
            return {
              id,
              title,
              requiredRemark: has_remark === 1,
              risk_level,
              risk: this.setRiskLevelText(risk_level),
              answer_setting_item: subTempItem.answer_setting_item,
              question_template_setting_items: subTempItem.question_template_setting_items,
            };
          })
        }
        return resultItem;
      });
      resultQues = {
        ...resultQues,
        option: answer_setting,
        optionList,
      };
    } else if (quesType.value === 'num') {
      resultQues = {
        ...resultQues,
        condition: answer_setting,
      };
      if (answer_setting.type === 'control-limit') {
        const {upper: controlUpper, lower: controlLower} = this.setControlSpecLimitValues(question_template_setting_items[0], 'controlLimit');
        const {upper: specUpper, lower: specLower} = this.setControlSpecLimitValues(question_template_setting_items[0], 'specLimit');
        resultQues = {
          ...resultQues,
          controlLimitDataLower: controlLower,
          controlLimitDataUpper: controlUpper,
          specLimitDataLower: specLower,
          specLimitDataUpper: specUpper,
          controlLimitData: `${controlLower} - ${controlUpper}`,
          specLimitData: `${specLower} - ${specUpper}`,
          controlLimitSuggest,
          specLimitSuggest,
        }
      } else if (answer_setting.type === 'custom-num') {
        const conditionList = question_template_setting_items.map(rawItem => {
          const {
            id,
            value,
            risk_level,
            value_operator,
            limit_lower,
            limit_upper,
          } = rawItem;
          return {
            id,
            value,
            risk_level,
            value_operator,
            limit_lower,
            limit_upper,
            operator: this.setOperatorText(value_operator),
            lowVal: value_operator !== 'in' || value_operator !== 'not_in'
              ? value
              : limit_lower,
            highVal: limit_upper,
            risk: this.setRiskLevelText(risk_level),
          };
        })
        resultQues = {
          ...resultQues,
          conditionList,
        }
      }
      if (unit) {
        resultQues = {
          ...resultQues,
          unit,
        }
      }
    }
    const lawList = H_common.setLawList(lastVersion);
    resultQues.lawLinks = lawList;
    resultQues.effects = [effects, []];
    if (lawList.length) {
      resultQues.lawList = null;
    } else {
      resultQues.lawList = '無';
    }
    return resultQues;
  },
  async setUpdateQues(rawData, type) {
    const {
      id,
      checklist_question_template: temp,
      has_bind: hasBindTempQues,
      last_version: lastVersion,
    } = rawData;
    const {
      id: versionId,
      question_type_setting,
      title,
      remark,
      template_attaches,
      ocap_remark: ocapRemark,
      act_version_alls,
      article_versions,
      effects,
      factory_effects: factoryEffects,
      keypoint,
      checklist_question_template_version: tempVersion,
      file_attaches,
      file_images,
      file_ocap_attaches,
      file_ocap_images,
      answer_setting: answerSetting,
      common_choice_group: commonChoiceGroup,
      is_in_stats: isInStats,
      question_setting_items: questionSettingItems,
      unit,
      related_guidelines,
    } = lastVersion;
    const lawList = H_common.setLawList({
      act_version_alls,
      article_versions,
    });
    const _effects = [];
    _effects.push(effects.map(effect => effect.id));
    _effects.push(factoryEffects.map(effect => effect.id));
    let resultQues = {
      id,
      versionId,
      quesType: question_type_setting.value,
      title: type === 'copy' ? `${title}-${i18n.t('複製')}` : title,
      remark,
      tempAttaches: H_file.setTempFileShowInModule(template_attaches),
      ocapRemark,
      lawList,
      effects: _effects,
      keypoint,
      tempId: temp ? temp.id : null,
      tempVersionId: tempVersion ? tempVersion.id : null,
      hasBindTempQues,
      controlLimitData: {
        upper: null,
        lower: null,
      },
      specLimitData: {
        upper: null,
        lower: null,
      },
      attaches: H_file.setShowInModule(file_attaches),
      images: H_file.setShowInModule(file_images),
      ocapAttaches: H_file.setShowInModule(file_ocap_attaches),
      ocapImages: H_file.setShowInModule(file_ocap_images),
      answerSetting,
      commonChoiceGroup,
      isInStats,
      questionSettingItems,
      unit,
      guidelineList: H_guidelineVersionAdmin.setUpdateRelatedGuideline(related_guidelines),
    };
    if (question_type_setting.value === 'num') {
      const numConditionType = await H_answerSetting.getNumConditionTypeFromId(answerSetting.id);
      resultQues = {
        ...resultQues,
        numConditionType: numConditionType.type,
      };
      if (numConditionType.type === 'control-limit') {
        const {control_limit_lower, control_limit_upper, spec_limit_lower, spec_limit_upper} = questionSettingItems[0];
        if ( control_limit_lower !== null && control_limit_upper !== null ) {
          resultQues.controlLimitData = {
            upper: control_limit_upper,
            lower: control_limit_lower,
          };
        }
        if ( spec_limit_lower !== null && spec_limit_upper !== null ) {
          resultQues.specLimitData = {
            upper: spec_limit_upper,
            lower: spec_limit_lower,
          };
        }
      } else if (numConditionType.type === 'custom-num') {
        resultQues.conditionList = questionSettingItems.map(({id, limit_lower, limit_upper, risk_level, value, value_operator: operator}) =>({
          id,
          lowVal: operator === 'in' || operator === 'not_in' ? `${limit_lower}` : `${value}`,
          highVal: operator === 'in' || operator === 'not_in' ? `${limit_upper}` : null,
          risk: `${risk_level}`,
          operator,
        }));
      }
    } else if (question_type_setting.value === 'single-choice') {
      resultQues.optionList = questionSettingItems.map(({answer_setting_item: answerSettingItem, common_choice: commonChoice, has_child, has_remark, id, name: title, question_setting_items, risk_level: risk}) => {
        const option = {
          answerSettingItem,
          answerSettingItemId: answerSettingItem && answerSettingItem.id ? answerSettingItem.id : null,
          commonChoice,
          commonChoiceId: commonChoice && commonChoice.id ? commonChoice.id : null,
          id,
          title,
          risk,
          hasSubOption: has_child === 1,
          requiredRemark: has_child === 1 ? false : !!has_remark,
          subOptionList: [],
        };
        if (has_child) {
          option.subOptionList = question_setting_items.map(({answer_setting_item: answerSettingItem, common_choice: commonChoice, has_remark, id, name: title, risk_level: risk}) => ({
            answerSettingItem,
            answerSettingItemId: answerSettingItem && answerSettingItem.id ? answerSettingItem.id : null,
            commonChoice,
            commonChoiceId: commonChoice && commonChoice.id ? commonChoice.id : null,
            id,
            title,
            risk,
            requiredRemark: has_remark === 1,
          }));
        }
        return option;
      });
    }
    return resultQues;
  },
  async setSubmitUpdateQues(rawQues, checklistVersionId) {
    const {
      id: checklist_question,
      attaches,
      ocapAttaches,
      tempAttaches,
      title,
      remark,
      ocapRemark: ocap_remark,
      lawList,
      effects,
      keypoint,
      isInStats,
      quesType,
      controlLimitData,
      specLimitData,
      tempVersionId,
      numConditionType,
      answerSetting,
      commonChoiceGroup,
      questionSettingItems,
      conditionList,
      optionList,
      unit,
      guidelineList,
    } = rawQues;
    const { actVersionAlls, articleVersions } = H_common.setSubmitActAndArticle(lawList);
    const quesTypeList = store.state.model.quesTypeList;
    const question_type_setting = quesTypeList.find(type => type.value === quesType).id;
    const tarNumConditionType = await H_answerSetting.getNumConditionTypeFromValue(numConditionType);
    const answer_setting = quesType === 'num'
      ? tarNumConditionType.id
      : quesType === 'single-choice' && answerSetting
      ? answerSetting.id
      : null;
    const resultQues = {
      checklist_question,
      attaches: H_file.setSubmitInModule(attaches),
      ocap_attaches: H_file.setSubmitInModule(ocapAttaches),
      template_attaches: tempAttaches.map(attach => attach.url),
      title,
      remark,
      ocap_remark,
      article_versions: articleVersions,
      act_version_alls: actVersionAlls,
      effects: effects[0],
      checklist_versions: [checklistVersionId],
      keypoint,
      question_type_setting,
      factory_effects: effects[1],
      checklist_question_template_version: tempVersionId,
      is_in_stats: this.setSubmitIsInStats({isInStats, quesTypeValue: quesType, numConditionTypeValue: numConditionType}),
      unit: quesType === 'num' ? unit : null,
      answer_setting,
      common_choice_group: quesType === 'single-choice' && commonChoiceGroup ? commonChoiceGroup.id : null,
      question_setting_items: [],
      related_guidelines: H_guidelineVersionAdmin.setSubmitRelatedGuideline(guidelineList),
    };
    if (quesType === 'num') {
      if (numConditionType === 'control-limit') {
        const id = questionSettingItems && questionSettingItems.length ? questionSettingItems[0].id : null;
        resultQues.question_setting_items = [{
          id,
          control_limit_lower: controlLimitData.lower,
          control_limit_upper: controlLimitData.upper,
          spec_limit_lower: specLimitData.lower,
          spec_limit_upper: specLimitData.upper,
        }]
      } else if (numConditionType === 'custom-num') {
        resultQues.question_setting_items = conditionList.map(({ id, risk: risk_level, operator: value_operator, highVal: limit_upper, lowVal: limit_lower}) => ({
          id,
          risk_level,
          value_operator,
          ...(value_operator === 'in' || value_operator === 'not_in'
              ? { limit_lower, limit_upper }
              : { value: limit_lower })
        }));
      }
    } else if (quesType === 'single-choice') {
      resultQues.question_setting_items = optionList.map(({id, hasSubOption, requiredRemark, risk: risk_level, title: name, subOptionList, answerSettingItemId, commonChoiceId }) => {
        const hasSubOptions = !!hasSubOption && subOptionList && subOptionList.length > 0;
        const option = {
          id,
          name,
          has_child: hasSubOptions,
          has_remark: hasSubOptions ? false : !!requiredRemark,
          risk_level,
          ...(answerSetting ? { answer_setting_item: answerSettingItemId } : commonChoiceGroup ? { common_choice: commonChoiceId } : {})
        };
        if (hasSubOptions) option.question_setting_items = subOptionList.map(({id, requiredRemark, risk: risk_level, title: name, answerSettingItemId, commonChoiceId }) => {
          return {
            id,
            name,
            has_remark: !!requiredRemark,
            risk_level,
            ...(answerSetting ? { answer_setting_item: answerSettingItemId } : commonChoiceGroup ? { common_choice: commonChoiceId } : {})
          };
        })
        return option;
      })
    }
    return resultQues;
  },
  async setCreateQuesWithVersion(rawQues, checklistData, createQuesFrom) {
    const {
      tempId,
      tempVersionId,
      tempAttaches,
      title,
      remark,
      attaches,
      ocapRemark: ocap_remark,
      ocapAttaches,
      keypoint,
      effects,
      lawList,
      numConditionType,
      answerSetting,
      commonChoiceGroup,
      optionList,
      quesType,
      isInStats,
      unit,
      controlLimitData,
      specLimitData,
      conditionList,
      guidelineList,
    } = rawQues;
    const question_type_setting = this.getQuesTypeFromIdOrValue(quesType, 'value').id;
    const currentFactoryId = store.state.app.factoryId;
    const {
      checklistId,
      checklistVersionId,
    } = checklistData;
    const { actVersionAlls: act_version_alls, articleVersions: article_versions} = H_common.setSubmitActAndArticle(lawList);
    let resultQues = {
      factory: currentFactoryId,
      checklists: [checklistId],
      checklist_versions: [checklistVersionId],
      question_type_setting,
      is_in_stats: this.setSubmitIsInStats({isInStats, quesTypeValue: quesType, numConditionTypeValue: numConditionType}),
      unit: quesType === 'num' ? unit : null,
      article_versions,
      act_version_alls,
      effects: effects[0],
      factory_effects: effects[1],
      title,
      remark,
      ocap_remark,
      attaches: H_file.setSubmitInModule(attaches),
      ocap_attaches: H_file.setSubmitInModule(ocapAttaches),
      keypoint,
      related_guidelines: H_guidelineVersionAdmin.setSubmitRelatedGuideline(guidelineList),
    };
      if (quesType === 'num') {
        const tarNumConditionType = await H_answerSetting.getNumConditionTypeFromValue(numConditionType);
        resultQues.answer_setting = tarNumConditionType.id;
        if (numConditionType === 'control-limit') {
          resultQues.question_setting_items = [{
            control_limit_lower: controlLimitData.lower,
            control_limit_upper: controlLimitData.upper,
            spec_limit_lower: specLimitData.lower,
            spec_limit_upper: specLimitData.upper,
          }]
        } else if (numConditionType === 'custom-num') {
          resultQues.question_setting_items = conditionList.map(({ risk: risk_level, operator: value_operator, highVal: limit_upper, lowVal: limit_lower }) => ({
            risk_level,
            value_operator,
            ...(value_operator === 'in' || value_operator === 'not_in'
                ? { limit_lower, limit_upper }
                : { value: limit_lower })
          }));
        }
      } else if (quesType === 'single-choice') {
        const question_setting_items = optionList.map(({answerSettingItemId, commonChoiceId, hasSubOption, requiredRemark, risk: risk_level, title: name, subOptionList}) => {
          const hasSubOptions = !!hasSubOption && subOptionList && subOptionList.length > 0;
          const option = {
            name,
            has_child: hasSubOptions,
            has_remark: hasSubOptions ? false : !!requiredRemark,
            risk_level,
            ...(answerSetting ? { answer_setting_item: answerSettingItemId } : commonChoiceGroup ? { common_choice: commonChoiceId } : {})
          };
          if (hasSubOptions) option.question_setting_items = subOptionList.map(({answerSettingItemId, commonChoiceId, requiredRemark, risk: risk_level, title: name}) => {
            return {
              name,
              has_remark: !!requiredRemark,
              risk_level,
              ...(answerSetting ? { answer_setting_item: answerSettingItemId } : commonChoiceGroup ? { common_choice: commonChoiceId } : {})
            };
          })
          return option;
        })
        resultQues = {
          ...resultQues,
          answer_setting: answerSetting ? answerSetting.id : null,
          common_choice_group: commonChoiceGroup ? commonChoiceGroup.id : null,
          question_setting_items,
        };
      }
    if (createQuesFrom === 'copy') {
      resultQues = {
        ...resultQues,
        checklist_question_template: tempId ? tempId : null,
        checklist_question_template_version: tempVersionId ? tempVersionId : null,
        template_attaches: tempAttaches.map(attach => attach.url),
      };
    }
    return resultQues;
  },
  changeTempQuesToUpdateQuesFormat(tempQues) {
    const {
      title,
      controlLimitDataLower,
      controlLimitDataUpper,
      specLimitDataLower,
      specLimitDataUpper,
      remark,
      tempAttaches,
      lawLinks: lawList,
      effects,
      versionId: tempVersionId,
      isInStats,
      quesType,
      option,
      condition,
      conditionList,
      optionList,
      unit,
    } = tempQues;
    const _effects = effects[0].map(effect => effect.id);
    let updateQues = {
      quesType: quesType.value,
      title,
      remark,
      tempAttaches,
      lawList,
      effects: [_effects, []],
      tempVersionId,
      isInStats,
    };
    if (quesType.value === 'num') {
      updateQues = {
        ...updateQues,
        numConditionType: condition.type,
        unit,
        answerSetting: condition.id,
      };
      if (condition.type === 'control-limit') {
        if ( controlLimitDataLower !== null && controlLimitDataUpper !== null ) {
          updateQues.controlLimitData = {
            upper: controlLimitDataUpper,
            lower: controlLimitDataLower,
          };
        }
        if ( specLimitDataLower !== null && specLimitDataUpper !== null ) {
          updateQues.specLimitData = {
            upper: specLimitDataUpper,
            lower: specLimitDataLower,
          };
        }
      } else if (condition.type === 'custom-num') {
        updateQues.conditionList = conditionList.map(({limit_lower, limit_upper, risk_level, value, value_operator: operator}) =>({
          lowVal: operator === 'in' || operator === 'not_in' ? `${limit_lower}` : `${value}`,
          highVal: operator === 'in' || operator === 'not_in' ? `${limit_upper}` : null,
          risk: `${risk_level}`,
          operator,
        }));
      }
    } else if (quesType.value === 'single-choice') {
      const _optionList = optionList.map(({answer_setting_item: answerSettingItem, hasSubOption, requiredRemark, title, question_template_setting_items, risk_level: risk}) => {
        const option = {
          answerSettingItem,
          answerSettingItemId: answerSettingItem.id,
          title,
          risk,
          hasSubOption,
          requiredRemark: hasSubOption ? false : !!requiredRemark,
          subOptionList: [],
        };
        if (hasSubOption) {
          option.subOptionList = question_template_setting_items.map(subTempItem => {
            const {
              name: title,
              risk_level: risk,
              has_remark,
            } = subTempItem.answer_setting_item;
            return {
              answerSettingItem: subTempItem.answer_setting_item,
              answerSettingItemId: subTempItem.answer_setting_item.id,
              title,
              risk,
              requiredRemark: has_remark === 1,
            };
          });
        }
        return option;
      });
      updateQues = {
        ...updateQues,
        answerSetting: option.id,
        optionList: _optionList,
      }
    }
    return updateQues;
  },
  setQuesSortingList(rawQuesList) {
    return rawQuesList.map(({ checklist_question, title }) => ({ id: checklist_question.id, title }));
  },
  setSubmitQuesSortingList(rawQuesList) {
    const order = rawQuesList.map((ques, quesIndex) => {
      return {
        id: ques.id,
        sequence: this.setSequence(quesIndex),
      }
    });
    return {
      order,
      factory: store.state.app.factoryId,
    }
  },
  setSequence(index) {
    const _index =  index + 1;
    const sequence = _index.toFixed().padStart(4, '0');
    return sequence;
  },
  setQuestionList(rawQuesList) {
    const resultQuesList = rawQuesList.map(ques => {
      const {last_version: lastVersion} = ques;
      const tempQuesStatus = ques.is_deleted_template
        ? {
            color: 'gray',
            text: '建議題目已移除'
          }
        : ques.is_renew_template
        ? {
            color: 'yellow',
            text: '建議題目版本更新'
          }
        : null;
      const effects = lastVersion.effects.map(effect =>{
        return {
          ...effect,
          color: 'red',
        }
      });
      const factoryEffects = lastVersion.factory_effects.map(effect =>{
        return {
          ...effect,
          color: 'red',
        }
      });
      const chips = [...effects, ...factoryEffects];
      return {
        id: ques.id,
        versionId: lastVersion.id,
        templateId: ques.checklist_question_template
          ? ques.checklist_question_template.id
          : null,
        templateVersionId: lastVersion.checklist_question_template_version
          ?lastVersion.checklist_question_template_version.id
          : null,
        quesType: lastVersion.question_type,
        sequence: ques.sequence,
        title: {
          text: lastVersion.title,
          chips,
        },
        keyPoint: lastVersion.keypoint,
        hasBindTempQues: ques.has_bind,
        tempQuesStatus,
        edit: {
          icon: 'icon-edit',
          color: 'blue',
        },
        copy: {
          icon: 'icon-copy',
          color: 'blue',
        },
        remove: {
          icon: 'icon-delete',
          color: 'red',
        },
      }
    });

    return resultQuesList;
  },
  setAssignmentDuration(rawData) {
    if (rawData.start_time && rawData.end_time) return `${H_time.getDateDashFormat(rawData.start_time, 'HH:mm')}-${H_time.getDateDashFormat(rawData.end_time, 'HH:mm')}`;
    else if (rawData.assignment_start_time && rawData.assignment_end_time) return `${H_time.getDateDashFormat(rawData.assignment_start_time, 'HH:mm')}-${H_time.getDateDashFormat(rawData.assignment_end_time, 'HH:mm')}`;
    return i18n.t('無');
  },
  setBoardChecklistList(type, ingSubTab, checklists) {
    if (!type || !ingSubTab || !checklists || checklists.length === 0) return [];
    const currentUser = store.state.stone_auth.currentUser;

    const mapChecklistAssignment = (item) => {
      const {
        id,
        checkers,
        checklist: parentChecklist,
        record_at: recordAt,
        reviewers,
        created_at
      } = item;
      const date = H_time.getDateDashFormat(recordAt);
      const duration = this.setAssignmentDuration(item);
      const isTemporary = ingSubTab === 'temporary';
      const result = {
        id,
        checklistId: parentChecklist.id,
        title: parentChecklist.name,
        date,
        duration,
        checkers: isTemporary
          ? checkers
          : this.setAnswerReviewRecord(checkers, 'answer'),
        reviewers: isTemporary
          ? reviewers
          : this.setAnswerReviewRecord(reviewers, 'review'),
      };
      const isCurrentUserChecked = checkers.some(
        checker => checker.id === currentUser.id && checker.checklist_record_answer
      );
      if (ingSubTab === 'today' || (ingSubTab === 'overdue' && !isCurrentUserChecked)) {
        result.rowItembutton = i18n.t('開始點檢');
      } else if ((ingSubTab === 'overdue' && isCurrentUserChecked) || ingSubTab === 'todayDone') {
        result.rowItembutton = i18n.t('查看點檢');
      } else if (ingSubTab === 'temporary') {
        result.createdAt = H_time.getDateDashFormat(created_at, 'YYYY-MM-DD HH:mm:ss');
        result.rowItemButtonList = Spare_checklistBoardTable.temporaryAssignmentRowItemButtonList;
      }
      return result;
    };

    const mapReviewResult = (record) => ({
      id: record.id,
      title: record.name,
      date: H_time.getDateDashFormat(record.record_at),
      checkers: this.setCheckerFromUpdatedUser(record),
      reviewers: this.setAnswerReviewRecord(record.reviewers, 'review'),
      rowItembutton: '查看結果',
      duration: this.setAssignmentDuration(record),
    });

    const riskLevelListResult = store.state.model.checklistRiskLevelList
      ? store.state.model.checklistRiskLevelList.filter(risk => risk.type === 'result')
      : [];

    const listMap = {
      checklistAssignment: () => checklists.map(mapChecklistAssignment),
      'review-assignment': () =>
        checklists.map((record) => ({
          id: record.id,
          date: H_time.getDateDashFormat(record.record_at),
          title: record.name,
          checkers: this.setCheckerFromUpdatedUser(record),
          reviewers: this.setAnswerReviewRecord(record.reviewers, 'review'),
          rowItembutton: record.review_remark ? '修改覆核' : '覆核',
          white: !!record.review_remark,
          duration: this.setAssignmentDuration(record),
        })),
      'checklist-result': () =>
        checklists.map((record) => {
          const {
            id,
            name: title,
            record_at: recordAt,
            reviewers,
            risk_level: riskLevelScore,
            pass_rate: passRate,
            status,
          } = record;
          const riskLevel =
            status == 1
              ? riskLevelListResult.find(risk => risk.score === null)
              : riskLevelScore === null
                ? { icon: 'icon-check-circle-filled', color: 'gray', text: '不涉及風險或不列入統計' }
                : riskLevelListResult.find(risk => risk.score == riskLevelScore);
          const passRateStr =
            status == 1
              ? '不需點檢'
              : passRate != null
                ? `${passRate}%`
                : '-%';
          return {
            id,
            title,
            date: H_time.getDateDashFormat(recordAt),
            checkers: this.setCheckerFromUpdatedUser(record),
            reviewers: this.setAnswerReviewRecord(reviewers, 'review'),
            riskLevel,
            passRate: passRateStr,
            rowItembutton: '查看結果',
            duration: this.setAssignmentDuration(record),
          };
        }),
      'review-result': () => checklists.map(mapReviewResult),
      'bereview-result': () => checklists.map(mapReviewResult),
    };

    const fn = listMap[type];
    return fn ? fn() : [];
  },
  setCheckerFromUpdatedUser(record) {
    const {checkers, updated_user: updatedUser, record_at: recordAt, status} = record;
    let _checkers = this.setAnswerReviewRecord(checkers, 'answer');
    if (status === '1') {
      _checkers = _checkers.map(checker => {
        if (checker.id === updatedUser.id) {
          checker = {
            ...checker,
            subTextLabel: '已完成',
            time: H_time.getDateDashFormat(recordAt, 'YYYY-MM-DD HH:mm:ss'),
          }
        }
        return checker;
      })
    }
    return _checkers;
  },
  setAnswerReviewRecord(rawData, type, isNeedSubTextLabel = true) {
    const isAnswer = type === 'answer';
    return rawData.map(({
      id,
      avatar,
      name,
      checklist_record_answer: recordAnswer,
      checklist_review_record: reviewRecord,
    }) => {
      const record = isAnswer ? recordAnswer : reviewRecord;
      return {
        id,
        avatar,
        name,
        subTextLabel: record && isNeedSubTextLabel ? '已完成' : null,
        time: record
          ? H_time.getDateDashFormat(record.updated_at, 'YYYY-MM-DD HH:mm:ss')
          : null,
      };
    });
  },
  setRecordAnalysisList(rawAnalysisList, filterState, selectedContentTabId, factorySystemClassRows = []) {
    const currentFactoryId = store.state.app.factory.id;
    const { duration: userSetDuration } = filterState;
    const riskLevelList = store.state.model.checklistRiskLevelList.filter(risk => risk.type == 'result');
    const getRiskIconList = (scoreNumList) => {
      return scoreNumList.map(item => {
        const riskLevel = riskLevelList.find(risk => risk.score == item.score);
        const { icon, color, backgroundColor } = riskLevel;
        return {
          icon,
          color,
          backgroundColor,
          num: item.num,
        };
      });
    };
    const getRemarkList = (recordCount, inCompleteAssignmentCount) => {
      const remarkList = [
        {text: i18n.t('已完成{number}筆',{number: recordCount})},
        {text: i18n.t('共{number}筆',{number: inCompleteAssignmentCount + recordCount})},
      ];
      if (inCompleteAssignmentCount > 0) {
        remarkList.unshift({
          color: 'red',
          text: i18n.t('未完成{number}筆',{number: inCompleteAssignmentCount})
        });
      }
      return remarkList;
    };
    const getTitleInfo = (subTitle) => {
      const matches = subTitle.match(/-/g);
      if (!matches) return null;
      if (matches.length === 4) {
        const dashIndex = H_checklistRecord.countDashIndex(subTitle, 1);
        return {
          date: subTitle.substring(dashIndex + 1),
          unit: 'month',
          format: 'YYYY-MM',
        };
      }
      if (matches.length === 2) {
        return {
          date: subTitle,
          unit: 'month',
          format: 'YYYY-MM',
        };
      }
      if (matches.length === 1) {
        return {
          date: subTitle,
          unit: 'year',
          format: 'YYYY',
        };
      }
      return null;
    };
    const setGroupTitle = (resultAnalysisList) => {
      let lastTitle = null;
      resultAnalysisList.forEach(item => {
        const titleInfo = getTitleInfo(item.subTitle);
        if (!titleInfo) return;
        const currentTitle = dayjs(titleInfo.date).startOf(titleInfo.unit).format(titleInfo.format);
        if (lastTitle === currentTitle) return;
        lastTitle = currentTitle;
        item.title = currentTitle;
      });
    };
    const analysisList = rawAnalysisList.map(rawRecord => {
      const {
        date,
        incomplete_assignments_count: inCompleteAssignmentCount,
        record_count: recordCount,
        risk_level_21_count: riskLevel21Count,
        risk_level_22_count: riskLevel22Count,
        risk_level_23_count: riskLevel23Count,
        risk_level_25_count: riskLevel25Count,
        system_class: systemClass,
        factory_system_class,
      } = rawRecord;
      const scoreNumList = [
        {
          score: 23,
          num: riskLevel23Count,
        },
        {
          score: 22,
          num: riskLevel22Count,
        },
        {
          score: 21,
          num: riskLevel21Count,
        },
        {
          score: 25,
          num: riskLevel25Count,
        },
      ];
      const riskIconList = getRiskIconList(scoreNumList);
      const remarkList = getRemarkList(recordCount, inCompleteAssignmentCount);
      const { start, end } = H_checklistRecord.setRecordAnalysisTimeDuration(date, selectedContentTabId, userSetDuration);
      const params = {
        system_classes: systemClass?.id,
        factory_system_classes: factory_system_class?.id,
        time_field: 'record_at',
        factory: currentFactoryId,
        start_time: start,
        end_time: end,
      };
      return {
        date,
        title: systemClass|| factory_system_class || {},
        riskIconList,
        remarkList,
        collapseFields: [
          {
            label: '點檢記錄',
            titleSize: 'h5',
            fetchUrl: `factory/${currentFactoryId}/checklist_record`,
            setTitle: () => {
              return i18n.t('共{number}份記錄',{number: recordCount})
            },
            setParams: () => params,
            setListData: list =>
              H_checklistRecord.setAnalysisRecordList(list, factorySystemClassRows),
            columnHeader: Spare_checklist.analysisColumnHeader.record,
            isShow: true,
          },
          {
            label: '未點檢作業',
            disable: true,
            titleSize: 'h5',
            fetchUrl: `v1/factory/${currentFactoryId}/checklist_assignment`,
            setTitle: () => {
              return i18n.t('共{number}筆未填',{number: inCompleteAssignmentCount})
            },
            setParams: () => ({...params, status: 1}),
            setListData: list =>
              H_checklistRecord.setAnalysisAssignmentList(list, factorySystemClassRows),
            columnHeader: Spare_checklist.analysisColumnHeader.assignment,
            isShow: true,
          },
        ]
      }
    });
    const analysisGroup = new Map();
    analysisList.forEach(record => {
      const date = record.date;
      if (!analysisGroup.has(date)) {
        analysisGroup.set(date, {
          subTitle: date,
          items: [],
        });
      }
      analysisGroup.get(date).items.push(record);
    });
    const resultAnalysisList = Array.from(analysisGroup.values());
    setGroupTitle(resultAnalysisList);
    return resultAnalysisList;
  },
  getTemplateCard(checklists) {
    checklists = S_systemClassAnalysis.userSystemSubclassesAuthCheck(checklists)
    if (!checklists || checklists.length === 0) return [];
    const data = checklists.map((checklist) => {
      return {
        id: checklist.id,
        title: checklist.name,
        tags: H_systemClassMenu.formatMultiSystemClassCardTags({
          system_classes: checklist.system_classes,
          system_subclasses: checklist.system_subclasses,
        }),
        spec: [
          {
            title: '頻率',
            text: checklist.frequency === 'day'
            ? i18n.t("每日")
            : checklist.frequency === 'week'
            ? i18n.t('週')
            : checklist.frequency === 'month'
            ? i18n.t('月')
            : checklist.frequency === 'season'
            ? i18n.t('季')
            : checklist.frequency === 'year'
            ? i18n.t('年')
            : checklist.frequency === 'everyTime'
            ? i18n.t('每次作業')
            : i18n.t('無'),
          },
          {
            title: '更新日期',
            text: H_time.getDateDotFormat(checklist.last_version.updated_at),
          },
        ],
        chips: H_card.setTags(checklist, ['updated', 'status']),
      };

    });
    return data;
  },
  getCard(checklists, factorySystemClassRows = []) {
    checklists = S_systemClassAnalysis.userSystemSubclassesAuthCheck(checklists)
    if (!checklists || checklists.length === 0) return [];
    const data = checklists.map((checklist) => {
      const {
        id,
        name,
        owner,
        is_collect,
        factory_tags,
        has_renew_template,
        system_classes,
        system_subclasses,
        factory_system_classes,
        factory_system_subclasses,
      } = checklist;
      return {
        id,
        title: name,
        tags: H_systemClassMenu.formatMultiSystemClassCardTags(
          { system_classes, system_subclasses, factory_system_classes, factory_system_subclasses },
          { factorySystemClassRows },
        ),
        spec: [
          {
            title: '管理者',
            text: owner?.name || '',
          },
        ],
        chips: has_renew_template
          ? [
              {
                color: 'yellow',
                text: '版本更新',
              },
            ]
          : [],
        isCollect: is_collect,
        factoryTags: H_factoryTag.setShowInModule(factory_tags),
      };
    });
    return data;
  },
  setLimitData(allLimitData) {
    const {controlLimitUpper, controlLimitLower, specLimitUpper, specLimitLower} = allLimitData;
    const controlLimitData = {
      upper:
        controlLimitUpper || controlLimitUpper === 0
          ? controlLimitUpper.toString()
          : null,
      lower:
        controlLimitLower || controlLimitLower === 0
          ? controlLimitLower.toString()
          : null,
    };
    const specLimitData = {
      upper:
        specLimitUpper || specLimitUpper === 0
          ? specLimitUpper.toString()
          : null,
      lower:
        specLimitLower || specLimitLower === 0
          ? specLimitLower.toString()
          : null,
    };
    const resultLimitData = {}
    if (
      controlLimitData.upper !== null &&
      controlLimitData.lower !== null
    ) {
      resultLimitData.controlLimitDataLower = controlLimitData.lower;
      resultLimitData.controlLimitDataUpper = controlLimitData.upper;
      resultLimitData.controlLimitData = `${controlLimitData.lower} - ${controlLimitData.upper}`;
    }
    if (
      specLimitData.upper !== null &&
      specLimitData.lower !== null
    ) {
      resultLimitData.specLimitDataLower = specLimitData.lower;
      resultLimitData.specLimitDataUpper = specLimitData.upper;
      resultLimitData.specLimitData = `${specLimitData.lower} - ${specLimitData.upper}`;
    }
    return resultLimitData;
  },
  async applyNumQuestionTypeShow(resultQues, { answerSetting, unit, questionSettingItems }) {
    const numConditionType = await H_answerSetting.getNumConditionTypeFromId(answerSetting.id);
    let merged = {
      ...resultQues,
      unit,
      numConditionType,
    };
    if (numConditionType.type === 'control-limit') {
      const {
        control_limit_lower: controlLimitLower,
        control_limit_upper: controlLimitUpper,
        spec_limit_lower: specLimitLower,
        spec_limit_upper: specLimitUpper
      } = questionSettingItems[0];
      merged = {
        ...merged,
        ...this.setLimitData({
          controlLimitLower,
          controlLimitUpper,
          specLimitLower,
          specLimitUpper
        }),
      };
    } else if (numConditionType.type === 'custom-num') {
      await S_answerSettingItem.updateOperatorListInVuex();
      merged.conditionList = questionSettingItems.map(({limit_lower, limit_upper, risk_level, value, value_operator}) => {
        return {
          lowVal: value_operator === 'in' || value_operator === 'not_in' ? limit_lower : value,
          highVal: value_operator === 'in' || value_operator === 'not_in' ? limit_upper : null,
          risk: this.setRiskLevelText(risk_level),
          riskValue: risk_level,
          operator: this.setOperatorText(value_operator),
          operatorValue: value_operator,
        };
      });
    }
    return merged;
  },
  setRecordTodayConclusion(rawData, effects) {
    const {
      effect_payload: effectPayload,
      keypoint_payload: keypointPayload,
      level_payload: levelPayload,
      pass_rate: passRate,
    } = Array.isArray(rawData) ? rawData[0] : rawData;
    if (!effectPayload && !keypointPayload && !levelPayload) return {};
    const effectList = [...effects];
    effectList.push({
      id: 'keypoint',
      name: '重點關注',
    });
    const riskNumList = ['majorNum', 'minorNum', 'ofiNum', 'passNum'];
    const invalidEffectNum = ['0', '0', '0', '1',];
    const resultList = [];
    effectList.forEach(effect => {
      const effectNumberList = effect.id === 'keypoint'
        ? keypointPayload
        : effectPayload.find(item => item.id === effect.id);
      if (!effectNumberList) return;
      let isEffectNumHide = true;
      if (effect.id === 'keypoint') {
        effectNumberList.number.forEach(num => {
          if (num !== 0) isEffectNumHide = false;
        })
      } else {
        invalidEffectNum.forEach((num, numIndex) => {
          if (effectNumberList.number[numIndex] !== num) isEffectNumHide = false;
        })
      }
      if (isEffectNumHide) return;
      const conclusion = {
        leadingImage: effect.icon,
        text: effect.name,
      };
      riskNumList.forEach((riskNum, riskNumIndex) => {
        conclusion[riskNum] = effectNumberList.number[riskNumIndex];
      });
      resultList.push(conclusion);
    })
    return {
      passRate,
      majorRiskNum: levelPayload.find(item => item.level == 23).number,
      minorRiskNum: levelPayload.find(item => item.level == 22).number,
      ofiRiskNum: levelPayload.find(item => item.level == 21).number,
      passNum: levelPayload.find(item => item.level == 25).number,
      resultList,
    };
  },
  setControlSpecLimitValues(rawData, tarType) {
    const {
      control_limit_lower,
      control_limit_upper,
      spec_limit_lower,
      spec_limit_upper,
    } = rawData;
    const upper = tarType === 'controlLimit'
      ? control_limit_upper.toString()
      : spec_limit_upper.toString();
    const lower = tarType === 'specLimit'
      ? control_limit_lower.toString()
      : spec_limit_lower.toString();
    return {upper, lower};
  },
  setRiskLevelText(riskLevelNumber) {
    if (!riskLevelNumber) return '';
    const riskList = store.state.model.checklistRiskLevelList && store.state.model.checklistRiskLevelList.length
      ? store.state.model.checklistRiskLevelList.filter(risk =>
          risk.type === 'question' &&
          (risk.score === '21' || risk.score === '22' || risk.score === '23' || risk.score === '25')
        ).map(risk => {return {id: risk.score, textLabel: risk.text}})
      : Spare_checklist.riskItems;
    const tarRisk = riskList.find(risk => risk.id === `${riskLevelNumber}`);
    return tarRisk ? i18n.t(tarRisk.textLabel) : '';
  },
  setOperatorText(operatorId) {
    if (!operatorId) return '';
    const operatorList = store.state.model.operatorList && store.state.model.operatorList.length
      ? store.state.model.operatorList.map(operator => {return {id: operator.value, textLabel: operator.name}})
      : Spare_checklist.operatorItems;
    const tarOperator = operatorList.find(risk => risk.id === operatorId);
    return tarOperator ? i18n.t(tarOperator.textLabel) : '';
  },
  getQuesTypeFromIdOrValue(data, type) {
    const quesTypeList = store.state.model.quesTypeList;
    return quesTypeList.find(ques => type === 'id' ? ques.id === data : ques.value === data);
  },
  setSubmitIsInStats({isInStats, quesTypeValue, numConditionTypeValue}) {
    if (quesTypeValue === 'date' || quesTypeValue === 'text') return 0;
    else if (quesTypeValue === 'single-choice') return isInStats === 1 ? 1 : 0;
    else if (quesTypeValue === 'num') return numConditionTypeValue === 'num-only'
      ? 0
      : isInStats === 1
      ? 1
      : 0;
  }
}
